import * as Yup from 'yup';

export const EmpresaSchema = Yup.object().shape({
  tipoInscricao: Yup.number().notRequired(),
  inscricao: Yup.mixed()
    .when('tipoInscricao', {
      is: 1,
      then: Yup.string()
        .test('is-cnpj', 'CNPJ deve conter 14 digitos', val => {
          if (!val) return true;
          return val.replace(/[^A-Za-z0-9]/g, '').length === 14;
        })
        .required('Campo requerido.'),
    })
    .when('tipoInscricao', {
      is: 2,
      then: Yup.string()
        .test('is-cpf', 'CPF deve conter 11 digitos', val => {
          if (!val) return true;
          return val.replace(/[^0-9]/g, '').length === 11;
        })
        .required('Campo requerido.'),
    }),
  razaoSocial: Yup.string()
    .max(85, ({ max }) => `Razão Social não pode exceder ${max} caracteres.`)
    .required('Campo requerido.'),
  emailPrincipal: Yup.string().email('O e-mail informado é inválido.'),
});
